import { Tabs } from 'antd';
import { filter, get, isEmpty, map } from 'lodash';
import React, { useEffect, useState } from 'react';
import {
  MOBILE_SCREEN_MAX_WIDTH,
  MOBILE_SHOW_FIELDS_NUMBER_SEO_FOOTER,
  TABLET_SHOW_FIELDS_NUMBER_SEO_FOOTER,
} from '../../common/helpers/constants';
import ShowMore from '../showMore/ShowMore';
import commonResource from '../../locales/th/common.json';
import { config } from './config/index';
import {
  CustomTab,
  SeoFooterAttribute,
  SeoFooterContent,
  SeoFooterSection,
  SeoFooterTab,
  SeoFooterTabContentWrapper,
  SeoFooterWrapper,
} from './SeoFooter.style';

const TabPane = Tabs.TabPane;

function SeoFooter() {
  const [popularLocations] = useState(get(config, 'popularLocations'));
  const [showPopularLocations, setShowPopularLocations] = useState(
    get(config, 'popularLocations'),
  );
  const [isShowMorePopularLocations, setIsShowMorePopularLocations] =
    useState(false);

  const [popularDevelopers] = useState(get(config, 'popularDevelopers'));
  const [showPopularDevelopers, setShowPopularDevelopers] = useState(
    get(config, 'popularDevelopers'),
  );
  const [isShowMorePopularDevelopers, setIsShowMorePopularDevelopers] =
    useState(false);

  const [popularSearchTerms] = useState(get(config, 'popularSearchTerms'));
  const [showPopularSearchTerms, setShowPopularSearchTerms] = useState(
    get(config, 'popularSearchTerms'),
  );
  const [isShowMorePopularSearchTerms, setIsShowMorePopularSearchTerms] =
    useState(false);

  const [popularSegments] = useState(get(config, 'popularSegments'));
  const [showPopularSegments, setShowPopularSegments] = useState(
    get(config, 'popularSegments'),
  );
  const [isShowMorePopularSegments, setIsShowMorePopularSegments] =
    useState(false);

  const [activeTabKey, setActiveTabKey] = useState('1');

  const [row, setRow] = useState(TABLET_SHOW_FIELDS_NUMBER_SEO_FOOTER);
  const showMoreText = commonResource.showMore.showMore;
  const showLessText = commonResource.showMore.showLess;
  const popularLocationsText = commonResource.seoFooter.popularLocations;
  const popularDevelopersText = commonResource.seoFooter.popularDevelopers;
  const popularSearchTermsText = commonResource.seoFooter.popularSearchTerms;
  const popularSegmentsText = commonResource.seoFooter.popularSegments;

  useEffect(() => {
    let newRow = TABLET_SHOW_FIELDS_NUMBER_SEO_FOOTER;
    if (window.innerWidth < MOBILE_SCREEN_MAX_WIDTH) {
      newRow = MOBILE_SHOW_FIELDS_NUMBER_SEO_FOOTER;
    }
    setRow(newRow);
    handleShowPopularLocations(popularLocations, newRow);
    handleShowPopularDevelopers(popularDevelopers, newRow);
    handleShowPopularSearchTerms(popularSearchTerms, newRow);
    handleShowPopularSegments(popularSegments, newRow);
  }, [
    popularDevelopers,
    popularLocations,
    popularSearchTerms,
    popularSegments,
  ]);

  const handleShowPopularLocations = (locations, newRow) => {
    const popularLocationsWithValue = filter(
      locations,
      (item) => !isEmpty(item.label),
    );
    if (popularLocationsWithValue.length > newRow) {
      setIsShowMorePopularLocations(true);
      setShowPopularLocations(popularLocationsWithValue.slice(0, newRow));
    } else {
      setShowPopularLocations(popularLocationsWithValue);
    }
  };

  const handleShowPopularDevelopers = (developers, newRow) => {
    const popularDevelopersWithValue = filter(
      developers,
      (item) => !isEmpty(item.label),
    );
    if (popularDevelopersWithValue.length > newRow) {
      setIsShowMorePopularDevelopers(true);
      setShowPopularDevelopers(popularDevelopersWithValue.slice(0, newRow));
    } else {
      setShowPopularDevelopers(popularDevelopersWithValue);
    }
  };

  const handleShowPopularSearchTerms = (projects, newRow) => {
    const popularSearchTermsWithValue = filter(
      projects,
      (item) => !isEmpty(item.label),
    );
    if (popularSearchTermsWithValue.length > newRow) {
      setIsShowMorePopularSearchTerms(true);
      setShowPopularSearchTerms(popularSearchTermsWithValue.slice(0, newRow));
    } else {
      setShowPopularSearchTerms(popularSearchTermsWithValue);
    }
  };

  const handleShowPopularSegments = (segments, newRow) => {
    const popularSegmentsWithValue = filter(
      segments,
      (item) => !isEmpty(item.label),
    );
    if (popularSegmentsWithValue.length > newRow) {
      setIsShowMorePopularSegments(true);
      setShowPopularSegments(popularSegmentsWithValue.slice(0, newRow));
    } else {
      setShowPopularSegments(popularSegmentsWithValue);
    }
  };

  const setTabItems = (obj) => {
    return map(obj, function (v, i) {
      return (
        <SeoFooterContent key={i}>
          <SeoFooterAttribute>
            <a href={v.link}>{v.label}</a>
          </SeoFooterAttribute>
        </SeoFooterContent>
      );
    });
  };

  const showPopularLocationsLessInfo = () => {
    const data = get(config, 'popularLocations');
    handleShowPopularLocations(data, row);
  };

  const showPopularDevelopersLessInfo = () => {
    const data = get(config, 'popularDevelopers');
    handleShowPopularDevelopers(data, row);
  };

  const showPopularSearchTermsLessInfo = () => {
    const data = get(config, 'popularSearchTerms');
    handleShowPopularSearchTerms(data, row);
  };

  const showPopularSegmentsLessInfo = () => {
    const data = get(config, 'popularSegments');
    handleShowPopularSegments(data, row);
  };

  const showPopularLocationsMoreInfo = () => {
    setShowPopularLocations(popularLocations);
    setIsShowMorePopularLocations(true);
  };

  const showPopularDevelopersMoreInfo = () => {
    setShowPopularDevelopers(popularDevelopers);
    setIsShowMorePopularDevelopers(true);
  };

  const showPopularSearchTermsMoreInfo = () => {
    setShowPopularSearchTerms(popularSearchTerms);
    setIsShowMorePopularSearchTerms(true);
  };

  const showPopularSegmentsMoreInfo = () => {
    setShowPopularSegments(popularSegments);
    setIsShowMorePopularSegments(true);
  };

  return (
    <SeoFooterWrapper className="seo-footer" data-test={'seo-footer'}>
      <SeoFooterSection>
        <SeoFooterTab>
          <Tabs onChange={(key) => setActiveTabKey(key)} moreIcon={null}>
            <TabPane
              tab={
                <CustomTab active={activeTabKey === '1'}>
                  {popularLocationsText}
                </CustomTab>
              }
              key="1"
              forceRender={true}
            >
              <SeoFooterTabContentWrapper>
                {setTabItems(showPopularLocations)}
              </SeoFooterTabContentWrapper>
              {isShowMorePopularLocations && (
                <ShowMore
                  showMoreText={showMoreText}
                  showLessText={showLessText}
                  className="detail-show-more"
                  showMoreInfo={() => showPopularLocationsMoreInfo()}
                  showLessInfo={() => showPopularLocationsLessInfo()}
                  isOnSeoFooter
                />
              )}
            </TabPane>
            <TabPane
              tab={
                <CustomTab active={activeTabKey === '2'}>
                  {popularDevelopersText}
                </CustomTab>
              }
              key="2"
              forceRender={true}
            >
              <SeoFooterTabContentWrapper>
                {setTabItems(showPopularDevelopers)}
              </SeoFooterTabContentWrapper>
              {isShowMorePopularDevelopers && (
                <ShowMore
                  showMoreText={showMoreText}
                  showLessText={showLessText}
                  className="detail-show-more"
                  showMoreInfo={() => showPopularDevelopersMoreInfo()}
                  showLessInfo={() => showPopularDevelopersLessInfo()}
                  isOnSeoFooter
                />
              )}
            </TabPane>
            <TabPane
              tab={
                <CustomTab active={activeTabKey === '3'}>
                  {popularSearchTermsText}
                </CustomTab>
              }
              key="3"
              forceRender={true}
            >
              <SeoFooterTabContentWrapper>
                {setTabItems(showPopularSearchTerms)}
              </SeoFooterTabContentWrapper>
              {isShowMorePopularSearchTerms && (
                <ShowMore
                  showMoreText={showMoreText}
                  showLessText={showLessText}
                  className="detail-show-more"
                  showMoreInfo={() => showPopularSearchTermsMoreInfo()}
                  showLessInfo={() => showPopularSearchTermsLessInfo()}
                  isOnSeoFooter
                />
              )}
            </TabPane>
            <TabPane
              tab={
                <CustomTab active={activeTabKey === '4'}>
                  {popularSegmentsText}
                </CustomTab>
              }
              key="4"
              forceRender={true}
            >
              <SeoFooterTabContentWrapper>
                {setTabItems(showPopularSegments)}
              </SeoFooterTabContentWrapper>
              {isShowMorePopularSegments && (
                <ShowMore
                  showMoreText={showMoreText}
                  showLessText={showLessText}
                  className="detail-show-more"
                  showMoreInfo={() => showPopularSegmentsMoreInfo()}
                  showLessInfo={() => showPopularSegmentsLessInfo()}
                  isOnSeoFooter
                />
              )}
            </TabPane>
          </Tabs>
        </SeoFooterTab>
      </SeoFooterSection>
    </SeoFooterWrapper>
  );
}

export default SeoFooter;
